'use client'

import { type FontSize, fontSizeMap } from '@mntn-dev/ui-theme'
import { createContext } from '../../utils/context.ts'

type DataListVariant = 'default' | 'subtle' | 'inverted'

type UseDataListProps = {
  fontSize?: FontSize
  variant?: DataListVariant
}

const useDataList = ({
  fontSize = 'med',
  variant = 'default',
}: UseDataListProps) => {
  return { fontSizeClassName: fontSizeMap[fontSize], variant }
}

const [DataListProvider, useDataListContext] = createContext<
  ReturnType<typeof useDataList>
>({ name: 'DataListContext' })

export {
  DataListProvider,
  useDataListContext,
  useDataList,
  type DataListVariant,
  type UseDataListProps,
}
